/*
 * Easing curves shared by the JS simulations and the CSS.
 *
 * Exports
 *   clamp(v, lo, hi), lerp(a, b, t)
 *   smoothstep(e0, e1, x)  Hermite step, 0 below e0 and 1 above e1
 *   smootherstep(u)        6u^5 - 15u^4 + 10u^3 (logistic-like elongation)
 *   easeOutCubic(u)        1 - (1 - u)^3 (decelerating expansion)
 *   EASE                   the same curves as CSS timing functions
 *
 * "Fast UI, slow nature": UI motion uses out/in, biology uses grow (linear:
 * a hypha's tip moves at constant speed), emerge and expand.
 */

export const clamp = (v, lo, hi) => (v < lo ? lo : v > hi ? hi : v);

export const lerp = (a, b, t) => a + (b - a) * t;

export function smoothstep(e0, e1, x) {
  if (e1 === e0) return x < e0 ? 0 : 1;
  const u = clamp((x - e0) / (e1 - e0), 0, 1);
  return u * u * (3 - 2 * u);
}

export function smootherstep(u) {
  const x = clamp(u, 0, 1);
  return x * x * x * (x * (x * 6 - 15) + 10);
}

export function easeOutCubic(u) {
  const x = 1 - clamp(u, 0, 1);
  return 1 - x * x * x;
}

export const EASE = {
  grow: 'linear',
  emerge: 'cubic-bezier(.45,0,.25,1)',
  expand: 'cubic-bezier(.2,.7,.2,1)',
  pop: 'cubic-bezier(.2,.9,.3,1)',
  out: 'cubic-bezier(.2,0,0,1)',
  in: 'cubic-bezier(.4,0,1,1)',
  sweep: 'cubic-bezier(.2,.55,.35,1)',
};
